import { makeVar } from '@apollo/client';

import { allWorkspaces } from 'configs/constants/sidebar';

export const workspaceVar = makeVar(allWorkspaces);
